import api from './HttpService';
import { GLOBAL } from '../configs/ApiActionUrl';

async function getClientStatus() {
  const res = await api.get(`${GLOBAL.GET_CLIENT_STATUS}/client`);
  return res;
}

async function getCountryStatus() {
  const res = await api.get(`${GLOBAL.GET_COUNTRY}/country`);
  return res;
}

async function getStateStatus(countryId) {
  const res = await api.get(`${GLOBAL.GET_STATE}/state/${countryId}`);
  return res;
}

async function getAddress() {
  const res = await api.get(`${GLOBAL.GET_ADDRESS}`);
  return res;
}

async function getStatus(module) {
  const res = await api.get(`${GLOBAL.GET_STATUS}/${module}`);
  return res;
}

async function getAllNotifications(page, search = '', status = '') {
  let query = '';

  if (page) {
    query += `?page=${page}`;
  }
  if (search) {
    // encodeURIComponent ensures special characters don't break the URL
    query += `${query ? '&' : '?'}search=${encodeURIComponent(search)}`;
  }
  if (status) {
    query += `${query ? '&' : '?'}status=${encodeURIComponent(status)}`;
  }

  try {
    const res = await api.get(`${GLOBAL.GET_ALL_NOTIFICATIONS + query}`);
    return res;
  } catch (error) {
    // Handle errors here
    return error; // Rethrow the error to propagate it further
  }
}

async function readNotification(code) {
  const res = await api.put(`${GLOBAL.READ_NOTIFICATION}/${code}/read`);
  return res;
}

async function readAllNotifications() {
  const res = await api.put(`${GLOBAL.READ_ALL_NOTIFICATIONS}`);
  return res;
}

const globalService = {
  getClientStatus,
  getCountryStatus,
  getStateStatus,
  getAddress,
  getStatus,
  getAllNotifications,
  readNotification,
  readAllNotifications
};

export default globalService;
